import styled from "styled-components";
import emailicon from "./img/email_black.png"
import passicon from "./img/vpn_key_black.png"
import { useForm } from "react-hook-form";
import SanitizePasswordFunction from "../../../Functions/SanitizePasswordFunction";
import { useContext, useEffect, useState } from "react";
import { ApiConnectLogRegister, ApiConnectUserLogon } from "../../../api/LionsUserApiConect";
import { PageContext } from "../../../Context/PageContext";
import Dashboard from "../Dashboard";
import RecoverAccount from "./RecoverAccount";
import { OpenPopMenu } from "../../../PopMenuWindow/PopMenuWindow";
import CloudFlareTurnstile from "../../../CloudFlareTurnstile/CloudFlareTurnstile";
import { useNavigate } from "react-router-dom";

function UserNotLogged() {

    const { register, getValues } = useForm();
    const navigate = useNavigate();
    const { isLogged, setIsLogged, user, setUser, setNoticeMessage, setPage, setPopMenuContent, setDashboardInitialPage} = useContext(PageContext)

      const [validEmail, setValidEmail] = useState(false);
      const [validPassword, setValidPassword] = useState(false);
      const [fieldMessage, setFieldMessage] = useState("");

      //const [submitItem, setSubmitItem] = useState(<CloudFlareTurnstile desiredFunction={CloudFlareChalenge}/>)
      const [submitItem, setSubmitItem] = useState(<LoginButton id="submitButton" onClick={() => tryLogin()}>LOGIN</LoginButton>)
          
          function CloudFlareChalenge() {
              setSubmitItem(<LoginButton id="submitButton" onClick={() => tryLogin()}>LOGIN</LoginButton>)
              setTimeout(() => {
                validateFields();
              }, 2000);
          }


    function checkEmailField (){

            let email = getValues('email')

            if(email === undefined) { return}
    
            if(email.length === 0) { 
                setFieldMessage("");
                return false
            }
    
            if(!email.includes("@") || email.length <=12) { 
                setFieldMessage("Formato de email inválido.");
                return false;
            }

            setFieldMessage("");
            return true;
    
        }
    
    
        function checkPasswordField () {
          let passContentField = getValues('userPassword')

            if(passContentField === undefined) { return }
    
            if(passContentField.length < 4 ) {
                setFieldMessage("");
                return false;
            }
    
            setFieldMessage("");
            return true
        }

        function validateFields() {

          let submit = document.getElementById('submitButton');

          if(!checkEmailField() || !checkPasswordField()){
            submit.style.pointerEvents = "none";
            submit.style.backgroundColor = "rgb(86, 87, 86)";
            submit.style.opacity = "0.7"
            return;
          }

          submit.style.backgroundColor = "rgb(12, 122, 27)";
          submit.style.pointerEvents = "auto";
          submit.style.opacity = "1"

        }



        async function tryLogin() {

          let userEmail = getValues('email');
          let userPass = getValues('userPassword');

          if(userEmail === "" || userPass === ""){ return;}
          
          let result = await ApiConnectUserLogon(userEmail, userPass);

          if(result === "NotFound") {
            setFieldMessage("Credenciais inválidas!")
          } else {

            sessionStorage.setItem('jwtToken', result.token);

            setIsLogged(true);
            //ApiConnectLogRegister(result.user, "Fez login no sistema ás: ");

            setUser(result.user);
           // setNoticeMessage( `Olá ${result.user.userName}! É um prazer vê-lo novamente obrigado por escolher nosso servidor ♥ `);

           navigate('/Conta');
           setDashboardInitialPage(<Dashboard />);
           setPage(<Dashboard />);
          }

        }

        document.addEventListener('keydown', (event) =>{
          if(event.keyCode === 13) {
            tryLogin();
          }
        })

        useEffect(() => {
          setTimeout(() => {  document.getElementById("NotLoggedContainer").style.opacity = 1}, 200)
            },[])


    return(
        <MasterContainer id="NotLoggedContainer">
            <h1>Faça login para acessar</h1>
            <span>E preciso fazer login para acessar o painel de controle. Ainda não tem uma conta?<br/>Clique na seção "Cadastro" para se cadastrar e venha agora mesmo para um mundo de aventuras!</span>
        
            <LoginPanelContainer>
                <BannerText>
                    <Title>
                      <GreenText>PAINEL DE LOGIN</GreenText>
                    </Title>
                </BannerText>
                <CredentialsContainer>
                  <form>
                        <FieldContainer>
                          <FieldIcon icon={emailicon}/>
                          <EmailInput placeholder="email"
                          {...register("email",{
                            onChange: () => {
                              validateFields();}}
                          )}
                          ></EmailInput>
                        </FieldContainer>
                        
                        <FieldContainer>
                          <FieldIcon icon={passicon}/>
                          <PasswordInput
                          placeholder="senha"
                          type="password"
                            {...register("userPassword", {
                                onChange: (e) => {
                                    var sanitizedPass = SanitizePasswordFunction(e.target.value);
                                    e.target.value = sanitizedPass;
                                     validateFields();
                                  }
                            })}
                            >
                          </PasswordInput>                          
                        </FieldContainer>
                        </form>
                </CredentialsContainer>
                <Notice>{fieldMessage}</Notice>
                <ForgotPassword
                onClick={() => {
                  OpenPopMenu();
                  setPopMenuContent(<RecoverAccount/>)
                }}
                >Esqueceu sua senha ?</ForgotPassword>
            </LoginPanelContainer>

            {submitItem}
            
        </MasterContainer>

    )
};


export default UserNotLogged;

const MasterContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    opacity: 0;
    transition: .7s;
    margin-bottom: 100px;
    //border: solid;

    @media(max-width: 1000px) {
    width: 90vw;
    
    }

`

const LoginPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 280px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
  margin-bottom: 20px;
  margin-top: 50px;
  border: solid 2px;
  box-shadow: 10px 10px 10px 0 black;
  //scale: 1.2;
`

const BannerText = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  //border: solid, 2px black;
  
`;

const Title = styled.h1`
  margin: 0;
  padding: 10px 0;
  text-align: center;
  z-index: 2;
  margin-bottom: -10px;

`;

const GreenText = styled.span`
  color: rgb(255, 255, 255);
  font-size: 32pt;
  //-webkit-text-stroke: 1px white;
  font-weight: bolder;
  margin: 10px;

    &:hover {
    filter: saturate(200%);
    transition: 1s  ease-in-out;
    cursor: pointer;
    }

    &:not(:hover) {
    filter: saturate(100%);
    transition: .2s  ease-in-out;
    cursor: pointer;
    }
`;

const BlueText = styled.span`
  color:rgb(33, 119, 240);
  //color:rgb(235, 235, 235);
  font-size: 60px;
  -webkit-text-stroke: 1px white;
  font-weight: bolder;
  font-family: Arial;

   &:hover {
    filter: saturate(400%);
    transition: 1s  ease-in-out;
    cursor: pointer;

    }

    &:not(:hover) {
    filter: saturate(100%);
    transition: 1s  ease-in-out;
    cursor: pointer;
    }
`;

const Hr = styled.hr`
  border: solid 1px rgb(33, 119, 240);
  width: 300px;
  margin: -2px auto -10px 0;
`;

const SubTitle = styled.h2`
  margin: 10px 0px 0px 0px;
  padding: 0;
  font-size: 24px;
  font-weight: bold;
  font-family: Arial;
  text-align: center;
  color:rgb(33, 119, 240);
  font-style: italic;
  -webkit-text-stroke: .3px white;
  z-index: 2;
`;

const CredentialsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

`

const FieldContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 15px;
`

const EmailInput = styled.input`
    height: 25px;
    width: 170px;
    border: ;
    font-size: 16px;
    border-radius: 5px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }
`

const PasswordInput = styled.input`
    height: 25px;
    width: 170px;
    border: ;
    font-size: 16px;
    border-radius: 5px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }
`

const FieldIcon = styled.div`
    background-image: url(${props => props.icon});
    background-size: cover;
    backgroun-repeat: no-repeat;
    background-position: center center;
    width: 25px;
    height: 25px;
    margin-right: 15px;
`

const Notice = styled.div`
  width: 210px;
  height: 20px;
  color: red;
  margin-bottom: 10px;
  font-weight: bold;
  text-align: center;
`
const ForgotPassword = styled.div`
  width: 210px;
  height: 20px;
  color: White;
  opacity: .3;
  margin-bottom: 10px;
  font-weight: bold;
  text-align: center;
  transition: .3s ease-in-out;
  cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

  &:hover {
  scale: 1.2;
  opacity: 1;

  }
`

const LoginButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    Padding: 0px 40px;
    background-color: rgb(86, 87, 86);
    scale: 1.0;
    border: none;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: .7;
    border-radius: 5px;
    transition: .3s ease-in-out;
    pointer-events: none;
    margin-top: 0px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {

    transform: translate(0px, -1px);
    filter: saturate(150%);
    }

`